import { render } from "./RegistryConfigs.vue?vue&type=template&id=fd674e5a"
import script from "./RegistryConfigs.vue?vue&type=script&lang=js"
export * from "./RegistryConfigs.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../github.com:rancher/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__